// extracted by mini-css-extract-plugin
export default {"svg":"MessageNode_svg__njOWb","placeholder":"MessageNode_placeholder__vu+yp","deleteIcon":"MessageNode_deleteIcon__Nzrk1"};